/* eslint-disable import/prefer-default-export */
export const REQUEST_PRICING_PROFILES = 'pricing-REQUEST_PRICING_PROFILES';
